import { render, staticRenderFns } from "./notallowed.vue?vue&type=template&id=be233e18&"
import script from "./notallowed.vue?vue&type=script&lang=js&"
export * from "./notallowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports